module.exports = __webpack_public_path__ + "assets/AirbnbCereal-Bold.21ace8cc5cdcd41248de41d0b47d08ac.woff2";